import { useTranslation } from "react-i18next";
import { useRecordContext } from "react-admin";
import { StatusLabel } from "../../../components/Label/status";
import QuickViewCard from "../../../components/Common/QuickViewCard";
import InfoRow from "../../../components/Common/InfoRow";
import { formatCrypto, formatDateTime } from "../../../utils/paymentFormat";
import { ProjectField } from "../ProjectField";
import { readable } from "./InfoKytTravelRuleTab";
import { Box } from "@mui/material";

function RecentActivity() {
  const { t }: { t: any } = useTranslation();
  const record = useRecordContext();
  if (!record) return null;

  return (
    <QuickViewCard>
      <InfoRow label={t("Status")}>
        <StatusLabel fontSize="small" statusField="statusOrder" />
      </InfoRow>
      <InfoRow label={t("Entity")}>
        <Box component="span" sx={{ "& .MuiTypography-root": { fontWeight: 700 } }}>
          <ProjectField />
        </Box>
      </InfoRow>
      <InfoRow label={t("Amount")}>
        {formatCrypto(record.amount)} {record.currency}
      </InfoRow>
      <InfoRow label={t("KYT rating")}>{readable(record.kytRating)}</InfoRow>
      <InfoRow label={t("Created date")}>{formatDateTime(record.dateCreated)}</InfoRow>
    </QuickViewCard>
  );
}

export default RecentActivity;
